module.exports = __webpack_public_path__ + "assets/img/qinzi_bg.189c97f5.jpg";